import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {documentTypes} from '../../util/uiconstants';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function taskDocumentRelateReducer(state = initialState.taskDocumentRelate, action) {
	switch (action.type) {
		case types.ASSOCIATE_TASK_DOCUMENTS:
			// this null state scenario comes in when we are associating documents after upload
			// at this time the state of taskrelate would be null
			// since the associate does not happen from taskrelate modal
			if (!state || action.error) {
				return state;
			}

			if (action.response && action.response.isDocumentNameAlreadyExists === true) {
				return state;
			}

			return Object.assign({}, state, {
				documents:
					state.documents &&
					state.documents.map((doc) => {
						let compareWith =
							action.meta.api.data.operationType === 1 ? action.response.documentId : action.meta.api.data.DocumentId;
						if (doc.documentId === compareWith) {
							return Object.assign({}, doc, {
								isAssociated: action.meta.api.data.operationType === 1 ? true : false
							});
						}
						return doc;
					})
			});
		case types.GET_TASK_DOCUMENT_RELATE: {
			let taskDocumentRelate = action.response;
			taskDocumentRelate.documents = action.response.data;

			if (action.response.data) {
				for (let i = 0; i < action.response.data.length; i++) {
					taskDocumentRelate.documents[i].isReturned =
						taskDocumentRelate.documents[i].documentTypeId === documentTypes.RETURNEDDOCUMENT ? true : false;

					taskDocumentRelate.documents[i].isReadOnly =
						[
							documentTypes.PRIORYEAREVIDENCE,
							documentTypes.CLIENTFILES,
							documentTypes.AUTOMATIONHUBOUTPUT,
							documentTypes.AUTOMATIONHUBCLIENTOUTPUT
						].indexOf(taskDocumentRelate.documents[i].documentTypeId) !== -1
							? true
							: false;
				}
			}
			return taskDocumentRelate;
		}
		case types.GET_DOCUMENT_TASK_RELATE: {
			let documentTaskRelate = {totalCount: action.response.totalCount};
			documentTaskRelate.availablePages = action.response.availablePages;

			if (action.response.taskGroups && action.response.taskGroups.length > 0) {
				documentTaskRelate.currentPage = action.response.taskGroups[0].currentPage;
				documentTaskRelate.list = action.response.taskGroups[0].tasks;
			} else {
				documentTaskRelate.currentPage = 0;
				documentTaskRelate.availablePages = 0;
				documentTaskRelate.list = [];
			}

			return {...documentTaskRelate};
		}
		case types.RESET_TASK_DOCUMENT_RELATE:
			return null;
		case types.UPDATE_TASK_DOCUMENT_RELATE: {
			return state;
		}
		case types.DELETE_TASK_DOCUMENT_RELATE: {
			return state;
		}
		default:
			return state;
	}
}
